import React from 'react';
import PropTypes from 'prop-types';
import {
  addDays,
  differenceInCalendarDays as diffDays,
  endOfDay,
} from 'date-fns';
import { Grid } from '@material-ui/core';
import DateInputFieldWithValidation from '../ValidationFormElements/DateInputFieldWithValidation';

const DateRange = (props) => {
  const {
    range,
    minRangeDays,
    maxRangeDays,
    labels,
    startProps,
    endProps,
    validationProps,
    onStartDateChange,
    onEndDateChange,
  } = props;

  const handleStartDateChange = (startDate) => {
    onStartDateChange(startDate);
    let { end } = range;
    if (startDate && end && minRangeDays) {
      const currentDiff = diffDays(end, startDate);
      if (currentDiff < minRangeDays || currentDiff > maxRangeDays) {
        end = null;
        onEndDateChange(end);
      }
    }
  };

  const handleEndDateChange = (endDate) => {
    const end = endDate && endOfDay(endDate);
    onEndDateChange(end);
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6}>
        <DateInputFieldWithValidation
          formProps={{ errors: validationProps.errors, clearError: validationProps.clearError }}
          labelKey={labels.start}
          name="start"
          value={range.start}
          handleChange={handleStartDateChange}
          maxDate={startProps.maxDate}
          minDate={startProps.minDate}
          required
          autoComplete="off"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DateInputFieldWithValidation
          formProps={{ errors: validationProps.errors, clearError: validationProps.clearError }}
          labelKey={labels.end}
          name="end"
          value={range.end}
          handleChange={handleEndDateChange}
          minDate={
            range.start
              ? addDays(range.start, minRangeDays - 1)
              : endProps.minDate || startProps.minDate
          }
          maxDate={range.start ? addDays(range.start, maxRangeDays - 1) : endProps.maxDate}
          disabled={endProps.disabled}
          required
          autoComplete="off"
        />
      </Grid>
    </Grid>
  );
};

DateRange.propTypes = {
  range: PropTypes.shape({
    start: PropTypes.instanceOf(Date),
    end: PropTypes.instanceOf(Date),
  }),
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
  minRangeDays: PropTypes.number,
  maxRangeDays: PropTypes.number,
  labels: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
  }),
  startProps: PropTypes.shape({
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    dateInputRef: PropTypes.oneOf([PropTypes.object, PropTypes.func]),
    disabled: PropTypes.bool,
  }),
  endProps: PropTypes.shape({
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    dateInputRef: PropTypes.oneOf([PropTypes.object, PropTypes.func]),
    disabled: PropTypes.bool,
  }),
  validationProps: PropTypes.shape({
    startName: PropTypes.string,
    endName: PropTypes.string,
    errors: PropTypes.shape({}),
    showMessage: PropTypes.bool,
    clearError: PropTypes.func,
  }),
};

DateRange.defaultProps = {
  range: {},
  onStartDateChange: () => {},
  onEndDateChange: () => {},
  minRangeDays: 0,
  maxRangeDays: Infinity,
  labels: {},
  startProps: {},
  endProps: {},
  validationProps: {},
};

export default DateRange;
